import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, MapPin, Newspaper } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";
import { SEO } from "@/components/SEO";
import { PageHero, Loading } from "@/components/shared";

export default function News() {
  const [posts, setPosts] = useState(null);
  useEffect(() => { api.get("/public/news").then((r) => setPosts(r.data)); }, []);
  const fmt = (d) => d ? new Date(d).toLocaleDateString("en-ZA", { day: "numeric", month: "short", year: "numeric" }) : "";

  return (
    <>
      <SEO title="News & Events | Brackenfell Junior Rugby Club" description="Latest club news, announcements and events from Brackenfell Junior Rugby Club." />
      <PageHero title="News & Events" subtitle="Club announcements, updates and upcoming events." />
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        {posts === null ? <Loading /> : posts.length === 0 ? (
          <div className="rounded-2xl bg-white p-16 text-center ring-1 ring-slate-200">
            <Newspaper className="mx-auto h-12 w-12 text-slate-300" />
            <p className="mt-4 text-slate-500">No news posts published yet. Check back soon.</p>
          </div>
        ) : (
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {posts.map((p) => (
              <Link key={p.id} to={`/news/${p.slug}`} className="group flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-all hover:-translate-y-1 hover:shadow-lg" data-testid={`news-card-${p.id}`}>
                <div className="h-48 bg-[#0B2A4A]">
                  {p.featured_image ? <img src={mediaUrl(p.featured_image)} alt={p.title} className="h-full w-full object-cover" /> : (
                    <div className="flex h-full items-center justify-center"><Newspaper className="h-12 w-12 text-white/20" /></div>
                  )}
                </div>
                <div className="flex flex-1 flex-col p-6">
                  {p.category && <span className="text-xs font-bold uppercase tracking-wider text-[#1E63D6]">{p.category}</span>}
                  <h2 className="mt-1 font-heading text-xl font-bold uppercase text-[#0B2A4A]">{p.title}</h2>
                  <div className="mt-2 flex flex-wrap gap-3 text-xs text-slate-500">
                    <span className="flex items-center gap-1"><Calendar className="h-3.5 w-3.5" />{fmt(p.event_date || p.publish_date)}</span>
                    {p.event_location && <span className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />{p.event_location}</span>}
                  </div>
                  <p className="mt-3 line-clamp-3 flex-1 text-sm text-slate-600">{(p.content || "").replace(/<[^>]+>/g, "").slice(0, 160)}</p>
                  <span className="mt-4 text-sm font-bold uppercase text-[#1E63D6]">Read more →</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </>
  );
}
